/**
 * Application configuration constants
 */

// WebSocket Configuration
const DEFAULT_PROD_WS_URL = 'wss://cmxwcs3bqd.execute-api.ap-south-1.amazonaws.com/prod';
const isLocalHost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const configuredWsUrl = import.meta.env.VITE_WS_URL;
const isProductionHost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'www.shatranj.live' || window.location.hostname === 'shatranj.live');
export const WS_URL = isProductionHost
  ? DEFAULT_PROD_WS_URL
  : (configuredWsUrl || (isLocalHost ? 'ws://localhost:3001' : DEFAULT_PROD_WS_URL));
export const WS_RECONNECT_DELAY = parseInt(import.meta.env.VITE_WS_RECONNECT_DELAY) || 3000;
export const WS_MAX_RECONNECT_ATTEMPTS = parseInt(import.meta.env.VITE_WS_MAX_RECONNECT_ATTEMPTS) || 5;

// App Configuration
export const APP_TITLE = import.meta.env.VITE_APP_TITLE || 'shatranj.live';
export const DEFAULT_PLATFORM = import.meta.env.VITE_DEFAULT_PLATFORM || 'lichess';

// Platform Configuration
export const PLATFORMS = [
  { id: 'all', name: 'All Platforms', color: 'bg-gray-600' },
  { id: 'lichess', name: 'Lichess', color: 'bg-green-600' },
  { id: 'chesscom', name: 'Chess.com', color: 'bg-blue-600' },
  { id: 'fide', name: 'FIDE', color: 'bg-purple-600' },
  { id: 'chess24', name: 'Chess24', color: 'bg-orange-600' }
];

// Data Type Configuration
export const DATA_TYPES = [
  { id: 'all', name: 'All' },
  { id: 'games', name: 'Games' },
  { id: 'tournaments', name: 'Tournaments' }
];

// Connection Status
export const CONNECTION_STATUS = {
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  RECONNECTING: 'reconnecting',
  FAILED: 'failed'
};
